import { Moment } from 'moment-timezone';
import { useEffect, useState } from 'react';

interface UseDatePickerParams {
  dateProps: Moment | null;
  onValueChange: (value: Moment | null) => void;
}

export const useDatePicker = (params: UseDatePickerParams) => {
  const { dateProps, onValueChange } = params;

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<Moment | null>(dateProps);

  const [tempValue, setTempValue] = useState<Moment | null>(dateProps);

  useEffect(() => {
    setValue(dateProps);
    setTempValue(dateProps);
  }, [dateProps]);

  function toggle() {
    setIsOpen(!isOpen);
  }

  function open() {
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  function onConfirmChange() {
    setValue(tempValue);
    onValueChange(tempValue ? tempValue.startOf('day') : null);
    setIsOpen(false);
  }

  function onTempChange(value: Moment | null) {
    setTempValue(value);
  }

  function onReset() {
    setTempValue(null);
  }

  return {
    value,
    isOpen,
    toggle,
    open,
    close,
    onTempChange,
    onConfirmChange,
    onReset
  };
};
